module.exports = __webpack_public_path__ + "static/media/cumiLogo.a13c911e.svg";